import { useNavigate } from 'react-router-dom';
import './error404.css';

function Error404() {
    const navigate = useNavigate();

    const redirectHome = () => {
        navigate('/');
    }

    return (
        <>
            <div className='container errorContainer'>
                <p className='errorTitlte'>Error 404</p>
                <p className='errorDescription'>Esta página no está disponible. Disculpa las molestias. ¡Prueba buscar otra cosa!</p>
                <button onClick={redirectHome}>REGRESAR AL INICIO</button>
            </div>
        </>
    )
}

export default Error404;